import { serviceQuestionBrandModalSliceDispatch } from "../../Constants/ReduxConstants";

//Every reducer needs initial state.
const initialState = {
    open: false,
    serviceQuestionBrandToAdd: [],
    serviceId: 0,
    brandId: 0
}

export default function serviceQuestionBrandModalSlice(state = initialState, action) {
    switch (action.type) {
        case serviceQuestionBrandModalSliceDispatch.setOpen: {
            return {
                ...state,
                open: action.payload
            }
        }
        case serviceQuestionBrandModalSliceDispatch.serviceQuestionBrandToAdd: {
            return {
                ...state,
                serviceQuestionBrandToAdd: action.payload
            }
        }
        case serviceQuestionBrandModalSliceDispatch.setServiceId: {
            return {
                ...state,
                serviceId: action.payload
            }
        }
        case serviceQuestionBrandModalSliceDispatch.setBrandId: {
            return {
                ...state,
                brandId: action.payload
            }
        }
        default:
            return state
    }
}
